import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { checkAuthorization } from '../../../helpers';
import { message } from 'antd'

export const getJobAllDetail = createAsyncThunk('getJobStatistics',
    
    async (object, { dispatch, getState }) => {
        const {userToken}= checkAuthorization()
        dispatch(gettingJobDetail())
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        myHeaders.append("pageNO", object?.pageNo)
        myHeaders.append("recordsPerPage", object?.pageSize)
        var requestOptions = {
            method: 'Post',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({name: object?.name, location: object?.location})
        };
        fetch(domainUrl + `/getAllJobs`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(jobResponse(result?.data))
                    dispatch(setPages({pageNo: object?.pageNo, pageSize: object?.pageSize, totalRecords: result?.totalRecords}))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(jobClear())
                message.error(error) 
            })
    }
)



const JobGetAllSlice = createSlice({
    name: 'jobgetapi',
    initialState: {
        jobData: null,
        loadJob: false,
        pagination:{
            pageNo:1,
            pageSize: 10,
            totalRecords:0,
        },
        filters: {
            name: '',
            location: ''
        },
    },
    reducers: {
        gettingJobDetail: state => {
            state.loadJob=true
            state.jobData=null
        },
        jobResponse: (state, action)=>{
            state.jobData= action.payload
            state.loadJob= false
        },
        jobClear: (state)=>{
            state.jobData= null
            state.loadJob= false
        },
        changeJobFilters: (state, action) => {
            state.filters = action.payload
        },
        setPages:(state, action)=>{
            state.pagination= action.payload
        }
    },
})
export const { 
    gettingJobDetail, jobResponse, jobClear,
    changeJobFilters, setPages
} = JobGetAllSlice.actions;
export default JobGetAllSlice.reducer;